var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconimport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 17.25C20 17.6642 20.3358 18 20.75 18H22.25C22.6642 18 23 18.3358 23 18.75V19.25C23 19.6642 22.6642 20 22.25 20H20.75C20.3358 20 20 20.3358 20 20.75V22.25C20 22.6642 19.6642 23 19.25 23H18.75C18.3358 23 18 22.6642 18 22.25V20.75C18 20.3358 17.6642 20 17.25 20H15.75C15.3358 20 15 19.6642 15 19.25V18.75C15 18.3358 15.3358 18 15.75 18H17.25C17.6642 18 18 17.6642 18 17.25V15.75C18 15.3358 18.3358 15 18.75 15H19.25C19.6642 15 20 15.3358 20 15.75V17.25ZM16 3C18.2091 3 20 4.79086 20 7V12.25C20 12.6642 19.6642 13 19.25 13H18.75C18.3358 13 18 12.6642 18 12.25V7C18 5.89543 17.1046 5 16 5H7C5.89543 5 5 5.89543 5 7V16C5 17.1046 5.89543 18 7 18H12.25C12.6642 18 13 18.3358 13 18.75V19.25C13 19.6642 12.6642 20 12.25 20H7C4.79086 20 3 18.2091 3 16V7C3 4.79086 4.79086 3 7 3H16Z",
    fill: "#3B5118"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconimport);
export default __webpack_public_path__ + "static/media/icon.import.d968d63960e9fb68f95099bee11cfdf8.svg";
export { ForwardRef as ReactComponent };